export const playlistRequirementsLink =
  'http://help.soundcamps.com/en/articles/4536944-terms-and-%D1%81onditions-for-%D1%81urators '

export const termsAndConditions =
  'http://help.soundcamps.com/en/articles/4536944-terms-and-conditions-for-curators'

export const landingPageUrl = 'https://soundcamps.com/'

export const policyLink = 'http://help.soundcamps.com/en/'
